import { ReturnStatement } from '@angular/compiler';
import { Question } from '../shared/question';
import { Response } from '../shared/response';
import { ApplicationStorage } from './applicationStorage';
//@ts-ignore
import moment from 'moment';

export class FeedbackSurveyPloom {

    age: any;
    segment: any;
    endgame: boolean;
    surveyOutroText: any;
    keepAge: any;
    surveyIntroText?: any

    question1: Question;
    question2: Question;
    question3: Question;
    question4: Question;
    question5: Question;
    question6: Question;
    question7: Question;
    question8: Question;
    // question9: Question;






    questions: Array<Question>;

    constructor(private applicationStorage: ApplicationStorage) {
        // this.surveyConsumerAgreement = false;//TODO
        this.endgame = false;

        //(0.1) 
        this.question1 = new Question(1, [],
            `Cum te simți să fii printre primii care încearcă noile sortimente Sobranie Sticks pentru Ploom (Marine, Velvet, Aquamarine)?`,
            'Pe o scală de la 1 la 5 (5 fiind cea mai mare apreciere)',
            'radio-inline',
            [new Response(1, '1'),
            new Response(2, '2'),
            new Response(3, '3'),
            new Response(4, '4'),
            new Response(5, '5'),
            ],
            false,
            'horizontal',
            undefined,
            undefined,
            undefined,
            '',
            true,
            true,
        );



        //(0.3) 
        this.question2 = new Question(2, [this.question1.id],  // 1a
            `Cum ți se pare noul sortiment Sobranie Sticks Marine?`,
            'Pe o scală de la 1 la 5 (5 fiind cea mai mare apreciere)',
            'radio-inline',
            [new Response(1, '1'),
            new Response(2, '2'),
            new Response(3, '3'),
            new Response(4, '4'),
            new Response(5, '5'),
            ],
            false,
            'horizontal',
            undefined,
            undefined,
            undefined,
            '',
            true,
            true,
            './assets/images/Marine.png'
        );

        this.question2.render = () => {
            this.age = false;
            // console.log("1111: ", this.questionGateAge);
            let question1Responses = this.question1.responses.filter(r => r.selected);

            if (question1Responses.length > 0) {
                this.endgame = false;
                // if (!/^\d+\.\s/.test(this.question2.text)) {
                //     this.question2.text = `${this.question2.id}. ` + this.question2.text;
                // }
                return true;

            } else {
                this.question2.responses.forEach(r => {
                    r.selected = false;
                });
                this.endgame = true;

            }
            return false;

        }

        this.question3 = new Question(3, [this.question2.id],  // 1a
            'Cum ți se pare noul sortiment Sobranie Sticks Velvet?',
            'Pe o scală de la 1 la 5 (5 fiind cea mai mare apreciere)',
            'radio-inline',
            [new Response(1, '1'),
            new Response(2, '2'),
            new Response(3, '3'),
            new Response(4, '4'),
            new Response(5, '5'),
            ],
            false,
            'horizontal',
            undefined,
            undefined,
            undefined,
            '',
            true,
            true,
            './assets/images/Velvet.png'

        );

        this.question3.render = () => {
            this.age = false;
            // console.log("1111: ", this.questionGateAge);
            let question2Responses = this.question2.responses.filter(r => r.selected);

            if (question2Responses.length > 0) {

                this.endgame = false;
                // if (!/^\d+\.\s/.test(this.question3.text)) {
                //     this.question3.text = `${this.question3.id}. ` + this.question3.text;
                // }

                return true;

            } else {
                this.question3.responses.forEach(r => {
                    r.selected = false;
                });
                this.endgame = true;

            }
            return false;

        }

        this.question4 = new Question(4, [this.question3.id],  // 1a
            'Cum ți se pare noul sortiment Sobranie Sticks Aquamarine?',
            'Pe o scală de la 1 la 5 (5 fiind cea mai mare apreciere)',
            'radio-inline',
            [new Response(1, '1'),
            new Response(2, '2'),
            new Response(3, '3'),
            new Response(4, '4'),
            new Response(5, '5'),
            ],
            false,
            'horizontal',
            undefined,
            undefined,
            undefined,
            '',
            true,
            true,
            './assets/images/Aquamarine.png'
        );

        this.question4.render = () => {
            this.age = false;
            // console.log("1111: ", this.questionGateAge);
            let question3Responses = this.question3.responses.filter(r => r.selected);

            if (question3Responses.length > 0) {
                this.endgame = false;
                // if (!/^\d+\.\s/.test(this.question4.text)) {
                //     this.question4.text = `${this.question4.id}. ` + this.question4.text;
                // }


                return true;

            } else {
                this.question4.responses.forEach(r => {
                    r.selected = false;
                });
                this.endgame = true;

            }
            return false;

        }

        this.question5 = new Question(5, [this.question4.id],  // 1a
            'Ce sortimente Sobranie Sticks pentru Ploom utilizezi în prezent?',
            '',
            'checkbox',
            [
                new Response(1, 'Bronze', [], './assets/images/Bronze.png'),
                new Response(2, 'Garnet', [], './assets/images/Garnet.png'),
                new Response(3, 'Gold', [], './assets/images/Gold.png'),
                new Response(4, 'Green', [], './assets/images/Green.png'),
                new Response(5, 'Silver', [], './assets/images/Silver.png'),
                new Response(6, 'Tan', [], './assets/images/Tan.png'),
                new Response(7, 'Teal', [], './assets/images/Teal.png'),
                new Response(8, 'Yellow', [], './assets/images/Yellow.png'),

            ],



            false,
            'vertical',
            '',
            1,
            false,
            '',
            true
        );

        this.question5.render = () => {
            this.age = false;
            let question4SelectedIds = this.question4.responses.filter(r => r.selected)


            if (question4SelectedIds.length > 0) {
                this.endgame = false;
                // if (!/^\d+\.\s/.test(this.question5.text)) {
                //     this.question5.text = `${this.question5.id}. ` + this.question5.text;
                // }

                return true;
            } else {
                this.question5.responses.forEach(r => {
                    r.selected = false;
                });
                this.endgame = true;

            }
            return false;

        }


        this.question6 = new Question(6, [this.question5.id],  // 1a
            'Intenționezi sa adaugi în ritualul tău zilnic unul dintre cele 3 sortimente noi?',
            '',
            'radio',
            [new Response(1, 'DA'),
            new Response(2, 'NU'),

            ],
            false,
            'horizontal',
            undefined,
            undefined,
            undefined,
            '',
            true

        );

        this.question6.render = () => {
            this.age = false;
            // console.log("1111: ", this.questionGateAge);
            let question5Responses = this.question5.responses.filter(r => r.selected);

            if (question5Responses.length > 0) {
                this.endgame = false;
                // if (!/^\d+\.\s/.test(this.question6.text)) {
                //     this.question6.text = `${this.question6.id}. ` + this.question6.text;
                // }


                return true;

            } else {
                this.question6.responses.forEach(r => {
                    r.selected = false;
                });
                this.endgame = true;

            }
            return false;

        }



        this.question7 = new Question(7, [this.question6.id],  // 1a
            'Pe care?',
            '',
            'checkbox',
            [new Response(1, 'Aquamarine', [], './assets/images/Aquamarine.png'),
            new Response(2, 'Marine', [], './assets/images/Marine.png'),
            new Response(3, 'Velvet', [], './assets/images/Velvet.png'),
            ],
            false,
            'vertical',
            '',
            1,
            false,
            '',
            true

        );

        this.question7.render = () => {
            this.age = false;
            // console.log("1111: ", this.questionGateAge);
            let question6Responses = this.question6.responses.filter(r => r.selected);

            if (question6Responses.length > 0 && question6Responses[0]?.text == 'DA') {
                this.endgame = false;
                // if (!/^\d+\.\s/.test(this.question7.text)) {
                //     this.question7.text = `${this.question7.id}. ` + this.question7.text;
                // }

                return true;

            } else {
                this.question7.responses.forEach(r => {
                    r.selected = false;
                });
                this.endgame = true;

            }
            return false;

        }


        this.question8 = new Question(8, [this.question6.id, this.question7.id],  // 1a
            'Vrei se ne mai comunici ceva?',
            '',
            'free-message',
            [
                new Response(1, ''),
            ],
            false,
            'horizontal',
            undefined,
            undefined,
            undefined,
            '',
            true

        );

        this.question8.render = () => {
            // if (this.endgame == true) { return false; }
            let question7Responses = this.question7.responses.filter(r => r.selected)
            let question6SelectedIds = this.question6.responses.filter(r => r.selected).map(resp => resp.text);


            // || (!this.question7.render() && question6SelectedIds.includes("NU"))
            if (question7Responses.length > 0 || (!this.question7.render() && question6SelectedIds.includes("NU"))) {
                this.endgame = false;
                // if (!/^\d+\.\s/.test(this.question8.text)) {
                //     this.question8.text = `${this.question8.id}. ` + this.question8.text;
                // }

                return true;
            }
            else {
                this.question8.responses.forEach(r => {
                    r.selected = false;
                    r.freeMessage = ''
                });
                return false;
            }

        }



        this.questions = [this.question1, this.question2, this.question3, this.question4, this.question5, this.question6, this.question7, this.question8,];

        // console.log(this.questions)

    }


    getQuestions(): Array<Question> {
        return this.questions;
    }






}




